const c = (n, t) => {
    const i = n[t];
    return i ? typeof i == "function" ? i() : Promise.resolve(i) : new Promise((s, o) => {
      (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(o.bind(null, new Error("Unknown variable dynamic import: " + t)));
    });
  },
  m = "en";
let l = {},
  r = m,
  j = {};
const f = () => {
    let n = {};
    if (r !== m) {
      if (l[r]) n = l[r];else if (r.includes("-")) {
        const t = r.split("-").shift(),
          i = Object.keys(l);
        for (const s of i) if (s.split("-").shift() === t) {
          n = l[s];
          break;
        }
      }
    }
    j = n;
  },
  b = n => {
    r = n.replace("_", "-"), f();
  },
  y = async n => {
    let t;
    try {
      t = await c( /* @__PURE__ */Object.assign({
        "../../intl/translations/_e.json": () => import("./_e.EevOEV8v.js"),
        "../../intl/translations/ar.json": () => import("./ar.I7Zqqg0w.js"),
        "../../intl/translations/bg.json": () => import("./bg.iYcxklHU.js"),
        "../../intl/translations/bn.json": () => import("./bn.V7W_-Ehd.js"),
        "../../intl/translations/ca.json": () => import("./ca.5ekkOc61.js"),
        "../../intl/translations/cs.json": () => import("./cs.fOTUg-dO.js"),
        "../../intl/translations/cy.json": () => import("./cy.ldBvabPP.js"),
        "../../intl/translations/da.json": () => import("./da.3Ompfbw9.js"),
        "../../intl/translations/de.json": () => import("./de.SGk8qVqr.js"),
        "../../intl/translations/el.json": () => import("./el.-eegc8_N.js"),
        "../../intl/translations/en_GB.json": () => import("./en_GB.JkN4Oncd.js"),
        "../../intl/translations/es.json": () => import("./es.il5WdC2W.js"),
        "../../intl/translations/et.json": () => import("./et.hQ_4XX1V.js"),
        "../../intl/translations/fa.json": () => import("./fa.I4pk32FM.js"),
        "../../intl/translations/fi.json": () => import("./fi.N_Fl2dbF.js"),
        "../../intl/translations/fr.json": () => import("./fr.BT4M-i3o.js"),
        "../../intl/translations/gl_ES.json": () => import("./gl_ES.nr6dgvVK.js"),
        "../../intl/translations/he.json": () => import("./he.j3yeZCPS.js"),
        "../../intl/translations/hi.json": () => import("./hi.e8LIVM3E.js"),
        "../../intl/translations/hr.json": () => import("./hr.KbBX8TsF.js"),
        "../../intl/translations/hu.json": () => import("./hu.07uxEPTK.js"),
        "../../intl/translations/id.json": () => import("./id.NfSkLm2b.js"),
        "../../intl/translations/it.json": () => import("./it.9UZXT1Cu.js"),
        "../../intl/translations/ja.json": () => import("./ja.2Nu4UqFx.js"),
        "../../intl/translations/ko.json": () => import("./ko.5eDh959n.js"),
        "../../intl/translations/lv.json": () => import("./lv.umncZZiY.js"),
        "../../intl/translations/ms.json": () => import("./ms.fUZ5LnL5.js"),
        "../../intl/translations/nl.json": () => import("./nl.rR99UzBE.js"),
        "../../intl/translations/no.json": () => import("./no.Lkn_ZJAt.js"),
        "../../intl/translations/pl.json": () => import("./pl.fLGg64g8.js"),
        "../../intl/translations/pt_BR.json": () => import("./pt_BR.rnf8S9BD.js"),
        "../../intl/translations/ro.json": () => import("./ro.nVMMDYKS.js"),
        "../../intl/translations/ru.json": () => import("./ru.mKbMbynZ.js"),
        "../../intl/translations/sk.json": () => import("./sk.k_HALXu5.js"),
        "../../intl/translations/sr.json": () => import("./sr.Ala7L-YW.js"),
        "../../intl/translations/sv.json": () => import("./sv.4YNs8_qp.js"),
        "../../intl/translations/th.json": () => import("./th.DpM7p_xD.js"),
        "../../intl/translations/tl.json": () => import("./tl.fLFXhRv1.js"),
        "../../intl/translations/tr.json": () => import("./tr.sjgD3Vw3.js"),
        "../../intl/translations/uk.json": () => import("./uk.wLUEmsRw.js"),
        "../../intl/translations/ur.json": () => import("./ur._Jk0_c9s.js"),
        "../../intl/translations/vi.json": () => import("./vi.zqQY2__E.js"),
        "../../intl/translations/zh_CN.json": () => import("./zh_CN.zRl6M0N_.js"),
        "../../intl/translations/zh_TW.json": () => import("./zh_TW.Zpyl34L_.js")
      }), `../../intl/translations/${n.replace("-", "_")}.json`);
    } catch (i) {
      try {
        t = await c( /* @__PURE__ */Object.assign({
          "../../intl/translations/_e.json": () => import("./_e.EevOEV8v.js"),
          "../../intl/translations/ar.json": () => import("./ar.I7Zqqg0w.js"),
          "../../intl/translations/bg.json": () => import("./bg.iYcxklHU.js"),
          "../../intl/translations/bn.json": () => import("./bn.V7W_-Ehd.js"),
          "../../intl/translations/ca.json": () => import("./ca.5ekkOc61.js"),
          "../../intl/translations/cs.json": () => import("./cs.fOTUg-dO.js"),
          "../../intl/translations/cy.json": () => import("./cy.ldBvabPP.js"),
          "../../intl/translations/da.json": () => import("./da.3Ompfbw9.js"),
          "../../intl/translations/de.json": () => import("./de.SGk8qVqr.js"),
          "../../intl/translations/el.json": () => import("./el.-eegc8_N.js"),
          "../../intl/translations/en_GB.json": () => import("./en_GB.JkN4Oncd.js"),
          "../../intl/translations/es.json": () => import("./es.il5WdC2W.js"),
          "../../intl/translations/et.json": () => import("./et.hQ_4XX1V.js"),
          "../../intl/translations/fa.json": () => import("./fa.I4pk32FM.js"),
          "../../intl/translations/fi.json": () => import("./fi.N_Fl2dbF.js"),
          "../../intl/translations/fr.json": () => import("./fr.BT4M-i3o.js"),
          "../../intl/translations/gl_ES.json": () => import("./gl_ES.nr6dgvVK.js"),
          "../../intl/translations/he.json": () => import("./he.j3yeZCPS.js"),
          "../../intl/translations/hi.json": () => import("./hi.e8LIVM3E.js"),
          "../../intl/translations/hr.json": () => import("./hr.KbBX8TsF.js"),
          "../../intl/translations/hu.json": () => import("./hu.07uxEPTK.js"),
          "../../intl/translations/id.json": () => import("./id.NfSkLm2b.js"),
          "../../intl/translations/it.json": () => import("./it.9UZXT1Cu.js"),
          "../../intl/translations/ja.json": () => import("./ja.2Nu4UqFx.js"),
          "../../intl/translations/ko.json": () => import("./ko.5eDh959n.js"),
          "../../intl/translations/lv.json": () => import("./lv.umncZZiY.js"),
          "../../intl/translations/ms.json": () => import("./ms.fUZ5LnL5.js"),
          "../../intl/translations/nl.json": () => import("./nl.rR99UzBE.js"),
          "../../intl/translations/no.json": () => import("./no.Lkn_ZJAt.js"),
          "../../intl/translations/pl.json": () => import("./pl.fLGg64g8.js"),
          "../../intl/translations/pt_BR.json": () => import("./pt_BR.rnf8S9BD.js"),
          "../../intl/translations/ro.json": () => import("./ro.nVMMDYKS.js"),
          "../../intl/translations/ru.json": () => import("./ru.mKbMbynZ.js"),
          "../../intl/translations/sk.json": () => import("./sk.k_HALXu5.js"),
          "../../intl/translations/sr.json": () => import("./sr.Ala7L-YW.js"),
          "../../intl/translations/sv.json": () => import("./sv.4YNs8_qp.js"),
          "../../intl/translations/th.json": () => import("./th.DpM7p_xD.js"),
          "../../intl/translations/tl.json": () => import("./tl.fLFXhRv1.js"),
          "../../intl/translations/tr.json": () => import("./tr.sjgD3Vw3.js"),
          "../../intl/translations/uk.json": () => import("./uk.wLUEmsRw.js"),
          "../../intl/translations/ur.json": () => import("./ur._Jk0_c9s.js"),
          "../../intl/translations/vi.json": () => import("./vi.zqQY2__E.js"),
          "../../intl/translations/zh_CN.json": () => import("./zh_CN.zRl6M0N_.js"),
          "../../intl/translations/zh_TW.json": () => import("./zh_TW.Zpyl34L_.js")
        }), `../../intl/translations/${n.split("-").shift()}.json`);
      } catch (s) {}
    }
    return t == null ? void 0 : t.default;
  },
  k = async n => {
    var i;
    const t = await y(n);
    t != null && (window.$upe_intl = {
      [n]: t
    }), b(n), l = (i = window.$upe_intl) != null ? i : {}, f();
  },
  h = (n, t) => t ? n.replace(/%?\{(.*?)}/g, (i, s) => t[s] === void 0 || t[s] === null ? i : t[s]) : n,
  g = (n, t) => {
    let i = n;
    if (r !== m) {
      const s = j[n];
      s && (i = s);
    }
    return h(i, t);
  },
  T = n => {
    let t = n.phrase;
    return t || (t = `{COUNT, plural, one {${n.singularPhrase}} other {${n.pluralPhrase}}}`), n.context && (t = n.context + "|" + t), t;
  },
  w = (n, t, i) => {
    let s = t;
    if (r !== m) {
      const o = T({
          context: n,
          phrase: t
        }),
        e = j[o];
      e && (s = e);
    }
    return h(s, i);
  },
  d = "pdlt-mention",
  _ = ["user"];
class p extends HTMLElement {
  /**
   * Create a new PdltMention element from a set of attributes.
   */
  static fromAttributes(_ref) {
    let {
      type: t,
      mentioner: i,
      mentionee: s
    } = _ref;
    if (window.customElements.get(d) == null) throw Error("PdltMention is not registered yet");
    const o = new p();
    return o.setAttribute("type", t), o.setAttribute("mentioner-id", i.hashid), o.setAttribute("mentionee-id", s.hashid), o.setAttribute("mentionee-username", s.username), o.textContent = s.display_name, o;
  }
  /**
   * Create a new PdltMention element from an HTML string.
   */
  static fromString(t) {
    if (window.customElements.get(d) == null) throw Error("PdltMention is not registered yet");
    const i = document.createElement("template");
    if (i.innerHTML = t, i.innerHTML !== t) return null;
    const s = i.content.firstElementChild;
    if (s === null) return null;
    const o = {
        type: s.getAttribute("type"),
        "mentioner-id": s.getAttribute("mentioner-id"),
        "mentionee-id": s.getAttribute("mentionee-id"),
        "mentionee-username": s.getAttribute("mentionee-username"),
        mentioneeDisplayName: s.textContent
      },
      e = new p();
    return Object.entries(o).forEach(_ref2 => {
      let [u, a] = _ref2;
      u === "mentioneeDisplayName" ? a !== null && (e.textContent = a) : a !== null && e.setAttribute(u, a);
    }), e;
  }
  get isValid() {
    return this.type === "user" ? this.mentionerId !== null && this.mentioneeId !== null && this.mentioneeUsername !== null && this.mentioneeDisplayName !== "" : !1;
  }
  get type() {
    const t = this.getAttribute("type");
    if (t === null) return null;
    const i = t;
    return _.includes(i) ? i : null;
  }
  get mentionerId() {
    return this.getAttribute("mentioner-id");
  }
  get mentioneeId() {
    return this.getAttribute("mentionee-id");
  }
  get mentioneeUsername() {
    return this.getAttribute("mentionee-username");
  }
  get mentioneeDisplayName() {
    return this.textContent;
  }
  toString() {
    return this.outerHTML;
  }
  connectedCallback() {
    this.type === "user" && this.renderProfileLink();
  }
  renderProfileLink() {
    var t;
    if (this.mentioneeUsername != null && this.mentioneeUsername !== "") {
      const i = `https://${window.location.hostname}/${this.mentioneeUsername}`;
      this.innerHTML = `<a href="${i}" target="_blank" data-bridged-link="profile" data-bridged-link-username="${this.mentioneeUsername}">${(t = this.mentioneeDisplayName) != null ? t : g("Someone")}</a>`;
    }
  }
}
export { d as M, p as P, k as i, w as p, g as t };